module.exports = __webpack_public_path__ + "img/bullet-tick.2f194d54.png";